'use strict';

/**
 * @ngdoc function
 * @name exhibitorPortaluiApp.filter:collateralFile
 * @description
 * # Collateral File
 * Directive of the exhibitorPortalApp
 */
(function (angular, window, undefined) {
  function collateralFile() {
    'ngInject'
        return function (input, EXSConfig, CurrentEvent, SWAPExhibitor) {
            if(arguments.length === 1)
                return typeof input === 'string' ? /.*(-.*)\..*/.exec(input.split('/').pop())
                    .reduce(function(acc, curr) { return acc && (acc = acc.replace(curr,'')) || (acc = curr); }, '') 
                : null;
            else {
                var rootURL = EXSConfig.AWS3CollateralRootURL.replace('{0}', CurrentEvent.ShowCode.toLowerCase());
                rootURL = rootURL.replace('{1}', SWAPExhibitor.Id)

                return rootURL + '/' + input;
            }
        };
    }

    angular.module('exhibitorPortalApp')
		.filter('collateralFile', collateralFile);
})(angular, window);
